export default "__VITE_ASSET__fcfed6c4__"